import { CommonEventApiClient } from '@soluto-private/common-event-api-client';
import config from 'packages/web-app/src/config';
import { AnalyticsEventModel } from 'shisell';

import { name as clientApplicationName, version as clientApplicationVersion } from '../../../../../package.json';
import { IAnalyticsWriter } from './IAnalyticsWriter';

const getEventIdentifier = ({ ExtraData, Name }: AnalyticsEventModel): string =>
  ExtraData && ExtraData.ActionId ? ExtraData.ActionId : Name;

class CommonEventAnalyticsWriter implements IAnalyticsWriter {
  private _client: CommonEventApiClient;

  constructor() {
    this._client = new CommonEventApiClient({
      clientApplicationName,
      clientApplicationVersion,
      url: config.COMMONEVENT_KINESIS_URL,
    });
  }

  public async isEnabled(): Promise<boolean> {
    return Promise.resolve(true);
  }

  public async write(eventModel: AnalyticsEventModel): Promise<void> {
    const { partner, Tags, SendAsCommonEvent } = eventModel.ExtraData;

    if (SendAsCommonEvent === true) {
      const { UserBrowserId } = eventModel.Identities;
      const eventIdentifier = getEventIdentifier(eventModel);
      const subType = `${eventIdentifier}`;

      const eventPayload = {
        type: 'SmartHomeWeb',
        subType,
        partner,
        identities: {
          userBrowserId: UserBrowserId,
        },
        data: eventModel,
        tags: Tags,
        dateTime: new Date().toISOString(),
      };

      await this._client.sendEvent(eventPayload);
    }
  }
}

export default new CommonEventAnalyticsWriter();



// WEBPACK FOOTER //
// ./packages/web-app/src/services/analyticsWriters/CommonEventAnalyticsWriter.ts